import wixWindow from 'wix-window';
import wixLocation from 'wix-location';


export function button2_click(event) {
	if ($w('#input1').value === '692119'){
		$w('#box2').show();

}
else if ($w('#input1').value === 'OR'){
		
		$w('#box2').show();
}
else if ($w('#input1').value === 'Or'){
		
		$w('#box2').show();
}
else if ($w('#input1').value === 'אור'){
		
		$w('#box2').show();
}
	else
			wixWindow.openLightbox("no");


}

export function vectorImage1_click(event) {
	$w('#box3').show();
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
}